import styled from 'styled-components'

export const LazyImageContainer = styled.div`
  display: block;
  width: 100%;
  height: auto;
  margin: ${(props) => props.theme.spacing.md} 0;
`
